import { useFeatureToggles } from '@grandvisionhq/state';
import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { fromAppointmentBannerToCampaignInfoBanner } from './adapters.js';

const emptyContent = {
    appointmentDisplayType: 'single',
    appointmentTypes: [],
    campaignInfoBanner: null,
    appointmentFaq: null
};
const useBloomreachAppointmentContent = ()=>{
    var ref, ref1, ref2, ref3, ref4;
    const page = useBrPageContext();
    const { isAabWithGroupedAppointmentTypesEnabled  } = useFeatureToggles();
    if (!page) {
        return emptyContent;
    }
    const reference1 = (ref1 = (ref = page.getComponent('main')) === null || ref === void 0 ? void 0 : ref.getModels()) === null || ref1 === void 0 ? void 0 : ref1.appointmentConfigurationDocument;
    if (!reference1) {
        return emptyContent;
    }
    if (!reference1.$ref) {
        return emptyContent;
    }
    const content = getBrPageContent(page, reference1);
    if (!content) {
        console.warn(`Cannot find main content for ProductDetail BR page. Got: ${content} for $ref: ${reference1.$ref}`);
        return emptyContent;
    }
    function mapAppointmentType(appointmentTypeRef) {
        const appointmentType = getBrPageContent(page, appointmentTypeRef);
        return {
            typeId: appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.typeId,
            icon: appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.icon,
            typeDetails: getBrPageContent(page, appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.typeDetails),
            appointmentConfirmationContent: getBrPageContent(page, appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.appointmentConfirmationContent)
        };
    }
    let appointmentTypesSingleOrGrouped;
    if (isAabWithGroupedAppointmentTypesEnabled) {
        appointmentTypesSingleOrGrouped = content.appointmentTypesGroup.map((group)=>{
            return {
                title: group === null || group === void 0 ? void 0 : group.groupTitle,
                icon: group === null || group === void 0 ? void 0 : group.groupIcon,
                appointmentTypes: group === null || group === void 0 ? void 0 : group.appointmentTypeCompound.map(mapAppointmentType)
            };
        });
    } else appointmentTypesSingleOrGrouped = content.appointmentTypes.map(mapAppointmentType);
    return {
        appointmentDisplayType: isAabWithGroupedAppointmentTypesEnabled ? 'group' : 'single',
        appointmentTypes: appointmentTypesSingleOrGrouped,
        campaignInfoBanner: fromAppointmentBannerToCampaignInfoBanner(content.appointmentBanner),
        // Because of the structure of the returned Bloomreach data we need to restructure it,
        // from objects that contain $ref to ones that contain an id, a question and an answer.
        appointmentFaq: {
            title: (ref2 = content.faqListAppointment) === null || ref2 === void 0 ? void 0 : ref2.title,
            faqItems: (ref3 = content.faqListAppointment) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.faqitem) === null || ref4 === void 0 ? void 0 : ref4.map((reference)=>getBrPageContent(page, reference)
            ).filter(({ type  })=>type === 'faqitem'
            ).map(({ id , question , answer  })=>({
                    id,
                    question,
                    answer: answer.value
                })
            )
        }
    };
};

export { useBloomreachAppointmentContent };
//# sourceMappingURL=use-bloomreach-appointment-content.js.map
